import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

import { IoIosCheckmark, IoIosArrowDown } from 'react-icons/io'
import Dropdown, { DropdownContainer } from '../Dropdown'
import GenevaDropdownOpener from '../GenevaDropdownOpener'

require('./styles.scss')

function AppSelect(props) {
  const { formatMessage } = props.intl

  let allowedApps = []
  
  if (props.applicationStore) {
    const nonObserved = props.applicationStore.collection
    // required ordering
    allowedApps = nonObserved.sort((first, second) => {
      switch (first.short) {
        case 'wm':
          return -1
        case 'am':
          return 1
        case 'mm':
          if (second.short === 'ms') {
            return -1
          }
          return 0
        default:
          return 0

      }
    })
  }
  
  // ref block.  Can be later removed
  // const allowedApps = [
  // 	{
  // 		acronym: 'WM',
  // 		backgroundColor: '#5C2D24',
  // 		name: 'Website Manager',
  // 		tagLine: 'Create, manage, and publish content',
  // 		url: 'http://api-am.beta.dachser.02.geneva.works/public/sso/wm'
  // 	},
  // 	{
  // 		name: 'Media Manager',
  // 		url: 'http://api-am.beta.dachser.02.geneva.works/public/sso/mm',
  // 		acronym: 'MM',
  // 		tagLine: 'Media organizer and storage',
  // 		backgroundColor: '#5D5324'
  // 	},
  // 	// {
  // 	//   name: 'Media Shop',
  // 	//   url: '///',
  // 	//   acronym: 'MS',
  // 	//   tagLine: 'app.ms-desc',
  // 	//   backgroundColor: '#1B3F2B'
  // 	// },
  // 	{
  // 		name: 'Application Manager',
  // 		url: `${global.GENEVA_CONFIG.AM_URL}/#/users`,
  // 		acronym: 'AM',
  // 		tagLine: 'User and Project management',
  // 		backgroundColor: '#333333'
  // 	}
  // ]

  const handleSelect = ({ currentTarget }) => {
    const app = currentTarget.name
    if (app === 'am') {
      window.location.href = `${global.GENEVA_CONFIG.AM_URL}/#/users`
    }
    // if (app !== '') {
    //   AMAPIWrapper.get(
    //     `sso/${app.toLowerCase()}`,
    //     (body) => {
    //       if (!body.success) {
    //         // const { formatMessage } = this.props.intl
    //         const message = formatMessage({ id: `app.${app}.login_failed` })
    //         alert(message)
    //       }
    //       else {
    //         window.location.href = body.url
    //       }
    //     }
    //   )
    // }
    
  }

  const activeView = allowedApps.find(app => (app.short === props.current))
    || {
      color: 'ff0000',
      id: '1234',
      name: 'Application Manager',
      short: 'rc',
      urlLogin: '',
      urlSSO: ''
    }

  return (
    <div
      className={classNames('appSelect', { bar: true })}
    >
      <DropdownContainer>
        <GenevaDropdownOpener
          disabled={!props.showDetails}
          caret={false}
          clickToClose
          className={classNames(
            'geneva-button page-dropdown-opener')}
        >
          <div
            className={classNames('appLink')}
            style={{
              backgroundColor: `#${activeView.color}`
            }}
          >
            {activeView.short.toUpperCase()}
          </div>
          <div className={classNames('dropdown', { hidden: !props.showDetails })} >
            <IoIosArrowDown />
          </div>
        </GenevaDropdownOpener>
        <Dropdown>
          {
            allowedApps
              .map((app) => {
                const active = (app.short === props.current)

                const link = app
                const tagline = link.description
              || formatMessage({ id: `app.${link.short}.description`, defaultMessage: '' })

                return (
                  <li id={link.short} key={link.short} className={classNames({ active })}>
                    <Link
                      name={link.short}
                      onClick={handleSelect}
                    >
                      <div
                        className={classNames(
                          'appLink',
                          { active }
                        )}
                        style={{
                          backgroundColor: active ? '#bbb' : `#${link.color}`
                        }}
                      >
                        {link.short.toUpperCase()}
                      </div>
                      {
                        props.showDetails
                          ? (
                            <div className={
                              classNames(
                                'appDescription',
                                { active }
                              )}>
                              <span
                                className={classNames('appTitle')}
                              >{link.name}
                              </span>
                              { props.current === link.short
                                ? <IoIosCheckmark />
                                : null
                              }
                              <span>
                                {tagline || 'temperary text, need translation'}
                              </span>
                            </div>
                          )
                          : null
                      }

                    </Link>
                  </li>)
              })
          }
        </Dropdown>
      </DropdownContainer>
    </div>)
}

AppSelect.propTypes = {
  current: PropTypes.string, // 'WM', 'MM', 'MS', 'AM'
  showDetails: PropTypes.bool
}

AppSelect.defaultProps = {
  current: 'rc',
  showDetails: true
}

export default injectIntl(AppSelect)
